import React, { useEffect, useState } from 'react';
import Universalpageheader from '../Headers/universalpageheader';
import Productcard from '../Products/productcard';
import { Button, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Searchbar from '../Components/searchbar';
import constants from "./../Utils/constants.json"
import { removeFromStore } from '../Utils/fn';
import { setFavorites } from '../../store/favorites';
import Errorcomponent from '../Components/errorcomponent';
import { setRecentlyViewed } from '../../store/recentlyViewed';
import { setAlert } from '../../store/alert';


function Recentlyviewedpage() {
    const dispatch = useDispatch();
    const subProducts = useSelector((state) => state.subProducts.data);
    const recentlyViewed = useSelector((state) => state.recentlyViewed.data);

    const [loading, setloading] = useState(false);
    const [showsearchbar, setshowsearchbar] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    function clearRecentlyViewed() {
        dispatch(setRecentlyViewed(null));
        removeFromStore(constants.RECENTLY_VIEWED);
        dispatch(setAlert({ type: 'success', message: 'Recently viewed cleared' }));
    }


    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"Recently Viewed"} withbackicon={true} />
            {loading && <div className='mainloadingdiv'><CircularProgress /></div>}
            <div >
                <div className='wrapfourcards' style={{ height: "80%" }}>
                    {recentlyViewed?.map((val, key) => {
                        return (
                            <Productcard product={val} key={key} showoffer={true} />
                        )
                    })}
                </div>
                {!recentlyViewed && <Errorcomponent error={"No recents"} />}
                {recentlyViewed?.length > 0 &&
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Button onClick={() => clearRecentlyViewed()}>CLEAR ALL</Button>
                    </div>
                }
            </div>
        </div>
    );
}


export default Recentlyviewedpage;
